import './sass/style.scss';
import './lib';

import React, { useCallback } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import useActions from './hooks/useActions';
import Routes from './routes';

function App() {
  const { authCheckState, getDesignations } = useActions();

  const checkAuth = useCallback(() => {
    authCheckState();
  }, [authCheckState]);

  const getStationDesignations = useCallback(() => {
    getDesignations();
  }, [getDesignations]);

  checkAuth();
  getStationDesignations();

  return (
    <div>
      <Router>
        <Routes />
      </Router>
      <ToastContainer
        position="top-left"
        autoClose={12000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
